import * as React from 'react';
import './simpleDesktopNavigation.module.scss';
import { observer } from 'mobx-react';
import { CurrentUserState } from '../../../../mainv2/states/CurrentUserState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { HeaderLogo } from '../../../components/atoms/Logo';
import DefaultUserProfile from '../default-user-profile.png';
import { NotificationIcon } from '../NotificationIcon';

type UserInfoProps = {
    currentUser: CurrentUserState;
};

const UserInfo = observer(({ currentUser }: UserInfoProps) => {
    if (currentUser.isSignedIn()) {
        const { name, profile_url } = currentUser.currentUser;
        return (
            <div id="user-info" styleName="user-info">
                <img styleName="profile" src={profile_url ? profile_url : DefaultUserProfile} />
                <div styleName="name">{name}</div>
            </div>
        );
    } else {
        return null;
    }
});

@observer
export class SimpleDesktopNavigation extends React.Component {
    render() {
        const currentUser = GlobalStatesV3.currentUser;
        return (
            <div styleName="nav">
                <div styleName="logo-wrapper">
                    <HeaderLogo styleName="logo" onClick={() => GlobalStatesV3.routing.push('/')} />
                </div>
                <div styleName="icons">
                    <NotificationIcon />
                    <UserInfo currentUser={currentUser} />
                </div>
            </div>
        );
    }
}
